<template>
  <div>
    
    <Menu />
    
    <section v-if="!$route.params.articleSlug">
      <div class="container-fluid g-0 pt-3">
        <div class="row g-0">
          <div class="col text-center">
            <div class="news-banner">
              <div class="row">
                <div class="col-lg-6 mx-auto align-self-center switch-white pb-5">
                  <h1 class="display-2 pb-5">Community News</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section v-if="$route.params.articleSlug">
      <div class="container" v-for="item in newsFeed.items" v-if="$route.params.articleSlug == item.app_link">
        <div class="row">
          <div class="col-md-12 p-3">
            <img :src="item.image" class="img img-fluid" />
            <h2 class="mt-4 mb-4" v-html="item.title"></h2>
            <div v-html="item.content_html" class="article-html" ref="articleContent"></div>
          </div>
        </div>
      </div>
    </section>

    <section v-if="!loading">
      <div class="container mt-4 bg-light p-3" v-for="item in newsFeed.items" v-if="item.tags[0] === feedName && $route.params.articleSlug !== item.app_link">
        <div class="row">
          <div class="col-md-4">
            <img :src="item.image" class="img img-fluid">
          </div>
          <div class="col-md-8 p-3">
              <h2>{{ item.title }}</h2>
              <p><small>Published on {{ new Date(item.date_published).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) }}</small></p>
              <p>{{ item.content_text.slice(0, item.content_text.split(" ").slice(0, 50).join(" ").length) }} ... </p>
              <a class="btn cta-btn" :href="'/news/' + item.app_link">Read more</a>
          </div>
        </div>
      </div>
    </section>
    
    <div class="mt-5"></div>

    <Footer />
  
  </div>
</template>
<script>

import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'

export default {
  components: {
    Menu, Footer 
  },
  mounted() {
    this.fetchNewsFeed()
  },
  beforeDestroy() {
    this.cleanupArticleVideos()
  },
  watch: {
    '$route.params.articleSlug'() {
      // Vue Router can reuse this component between different articles.
      this.cleanupArticleVideos()
      this.$nextTick(() => this.setupArticleVideos())
    }
  },
  data() {
    return {
      feedName: 'winelands',
      newsFeed: [],
      loading: true
    }
  },
  methods: {
    cleanupArticleVideos() {
      if (this._articleVideoObserver) {
        this._articleVideoObserver.disconnect()
        this._articleVideoObserver = null
      }
      if (this._articleVideos) {
        this._articleVideos.forEach(video => {
          video.pause()
        })
        this._articleVideos = null
      }
    },
    setupArticleVideos() {
      this.cleanupArticleVideos()
      if (!this.$route.params.articleSlug || typeof window === 'undefined' || !('IntersectionObserver' in window)) return

      // HTML from WordPress is inserted using v-html, so we locate native
      // <video> elements after Vue has finished updating the article DOM.
      const roots = this.$refs.articleContent || []
      const containers = Array.isArray(roots) ? roots : [roots]
      const videos = containers.reduce((all, el) => {
        if (el) all.push(...el.querySelectorAll('video'))
        return all
      }, [])
      if (!videos.length) return

      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      videos.forEach(video => {
        video.controls = true
        video.muted = true
        video.playsInline = true
        video.setAttribute('playsinline', '')
        video.preload = 'metadata'
      })
      this._articleVideos = videos
      if (reducedMotion) return // Keep manual playback available.

      this._articleVideoObserver = new window.IntersectionObserver(entries => {
        entries.forEach(entry => {
          const video = entry.target
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6 && !document.hidden) {
            // Do not allow multiple article videos to play simultaneously.
            videos.forEach(other => {
              if (other !== video && !other.paused) other.pause()
            })
            if (video.paused && !video.ended) {
              const playAttempt = video.play()
              if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(() => {})
            }
          } else if (!video.paused) {
            video.pause()
          }
        })
      }, { threshold: [0, 0.6] })
      videos.forEach(video => this._articleVideoObserver.observe(video))
    },
    fetchNewsFeed: async function () {
      this.loading = true;
      try {
        const response = await axios.get('https://luxury-dev.chaseveritt.co.za/news/feed/json/?per_page=20', {
          headers: {
            'Accept': 'application/json',
          }
        });
        this.newsFeed = response.data;
        this.newsFeed.items.forEach(item => {
          const urlParts = item.url.split('/');
          const slug = urlParts[urlParts.length - 2];
          item.app_link = slug;
        });
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      this.$nextTick(() => this.setupArticleVideos())
    }
  }
}
</script>
<style scoped>
.article-html img {
  width: 100% !important;
}
</style>

<style>
/* WordPress inserts the video through v-html, outside Vue's scoped styling. */
.article-html video {
  max-width: 100%;
  height: auto;
}
@media (max-width: 767px) {
  .article-html video {
    width: 100% !important;
  }
}
</style>